import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { LayoutAdminModule } from '../../layout/admin/layout-admin.module';
import { SharedModule } from '../../shared/shared.module';
import { IntegrationSettingsComponent } from './integration-settings.component';
import { IntegrationSettingsRoutes } from './integration-settings.routes';

@NgModule({
    declarations: [IntegrationSettingsComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatSlideToggleModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatIconModule,
        IntegrationSettingsRoutes,
        LayoutAdminModule,
        SharedModule
    ]
})
export class IntegrationSettingsModule {}
